//资源库首页搜索组件
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../base/BaseComponent";
import { Input,  Select,Icon } from 'antd';
import {getInfoFromLocalStorage} from "../../../../../actions";
import {findObject} from "../../../../editor/floatTool/securityCheck";
import MedialSelect from "../../../../editor/toolsSpace/tools/components/medialSelect";
import localUpload from "../../../../editor/toolsSpace/tools/components/img/localUpload.png";
import resourceSelect from "../../../../editor/toolsSpace/tools/components/img/resourceSelect.png";
import address from "../../../../editor/toolsSpace/tools/components/img/address.png";
import PhotoUpload from "../../../../editor/components/photoUpload/PhotoUpload";
import CurrencyResourceDialog from "../../dialog/CurrencyResourceDialog";
import {uuid} from "../../../../../utils";
import UploadWall from "../../../../../components/upload/UploadWall";
import {PIC_TYPE} from "../../../../../constants";
import {message} from "../../../components/Mess";
const InputGroup = Input.Group;
const { Option } = Select;
const { Search } = Input;

export default class SearchModule  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);

        this.state = {
            keyword:''
        }
    }

    componentWillMount() {
    }
    componentDidMount() {

    }
    render() {
        let data =  JSON.parse(this.sysConfigGetValueByKey("zyk_correct_format", '["jpg", "jpeg", "png", "bmp", "webp", "JPG", "JPEG", "PNG", "BMP", "WEBP"]'));
        let accept = "." + data.join(",.");
        let array = JSON.parse(JSON.stringify(accept)).toLowerCase();
        let arr = array.split(",");
        let newArray = [];
        //打开弹框的时候  过滤掉重复的格式
        arr && arr.length && arr.forEach((item, index) => {
            if (newArray.indexOf(item) > -1) {
            } else {
                newArray.push(item)
            }
        });
        newArray = newArray.toString();
        return(
            <div  style={{margin:'0 auto',width:'800px',position: "relative"}} key={this.state.key}>
                <InputGroup compact style={{height:'40px'}}>
                    <Search
                        placeholder="请输入"
                        enterButton="搜索"
                        allowClear
                        value={this.state.keyword}
                        size="large"
                        onChange={(e) => {
                            this.state.keyword = e.target.value;
                            this.setState({}, () => {
                            })
                        }}
                        onSearch={value => {
                                this.props.search&& this.props.search(value)
                        }}
                        suffix={
                            <UploadWall
                                style={{ width: "auto", height:'20px'}}
                                accept={newArray}
                                multiple={false}
                                action="/dynamic/storage/uploadFile"
                                showUploadBtn={true}
                                showUploadDisplayBtn={false}
                                listType="list"
                                beforeUpload={this.beforeUpload}
                                uploadBtnName={
                                    <div style={{ width: '20px',marginLeft:'5px'}}> <Icon type="camera" style={{fontSize: '20px'}}></Icon></div>
                                }
                                onChange={this.handleChange}
                            />
                        }
                        style={{height: '40px', width: '95%',cursor:'pointer'}}
                    />
                </InputGroup>
                <style>{` #Search  .ant-select-selection{background:#F5F5F5}
                          #Search  .ant-select-selection__rendered {line-height:40px}
                          #Search  .ant-select-selection--single{height:40px}
                `}</style>
            </div>
        )
    }
    //上传之前
    beforeUpload = async file => {

        let data = JSON.parse(this.sysConfigGetValueByKey("zyk_correct_format", '["jpg", "jpeg", "png", "bmp", "webp", "JPG", "JPEG", "PNG", "BMP", "WEBP"]'));
        console.log(file.name,data);
        let res = data.find(item => file.name.endsWith(item));
        return new Promise((resolve, reject) => {
            if (res) {
                resolve()
            } else {
                message.error('暂不支持该文件类型！');
                reject();
            }
        });
    };
    handleChange = info => {
        if (info.file.status === 'done') {
            this.props.searchCallBack&&this.props.searchCallBack(info)
        }
    };
    init = () =>{
        this.state.keyword = '';
        this.setState({})
    }

}
